import {
  RequrstBack,
  queryInitStatClientConfig,
} from '@/pages/datalab/pages/BehaviorAnalysis/GptAnalysis/hooks';
import http from '@/utils/http';
import { COMBINEID_REG } from '@intelligence/utils/constant';
import { useRequest } from 'ahooks';
// company detail financials  Similar Companies

export const useSimilar = <T>(params: T) => {
  if (!params?.uuid) return {};
  if (!COMBINEID_REG.test(params.uuid)) return {}; // 添加ID校验规则

  const fetch = (mutateParams: T) =>
    http({
      url: '/api/v1/intelligence_pc/detail/company/getIntelligenceDetailCompanyAbout',
      method: 'post',
      data: params,
      ...mutateParams,
    }) as RequrstBack;
  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    refreshDeps: [params],
    ready: !!params,
    cacheKey: 'similar',
    manual: false,
    loadingDelay: 0,
    debounceWait: 0,
  });
  return {
    ...data,
  };
};

// company detail Revenue Filter
export const useRevenueFilter = <T>(params: T) => {
  const fetch = (mutateParams: T) =>
    http({
      url: '/api/v1/intelligence_pc/filterListRegionCountry',
      method: 'post',
      data: params,
      ...mutateParams,
    }) as RequrstBack;
  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    refreshDeps: [params],
    ready: !!params,
    cacheKey: 'revenueFilter',
    manual: false,
    debounceWait: 0,
  });
  return {
    ...data,
  };
};
